import { useCanViewAs } from 'components/Can'
import { UserRole } from 'types'
import { useCurrentArticleMeta } from 'hooks/useCurrentArticleMeta'
import { SingleMenuDropdownContext } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownStore'
import { useContext } from 'react'
import { SingleMenuDropdownItem } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownItem'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const InsertMentionButton = () => {
  const view = useEditorView()
  const dropdownStore = useContext(SingleMenuDropdownContext)
  const currentArticle = useCurrentArticleMeta()
  const openMention = () => {
    view.dispatch(view.state.tr.insertText('@'))
    dropdownStore?.hardClose()
  }
  const canViewAs = useCanViewAs(currentArticle?.almanac_file.workspace.id || null)

  const disabled = !canViewAs([UserRole.GUEST, UserRole.MEMBER, UserRole.ADMIN, UserRole.SUPER_ADMIN])

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.Mention} />}
      label="Mention"
      handleClick={openMention}
      disabled={disabled}
    />
  )
}
